import * as tslib_1 from "tslib";
import { JobTriggerBaseComponent } from '@pages/jobs/grids/job-triggers';
import { QueueItemService } from '@services';
var JobTriggerQueueItemComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobTriggerQueueItemComponent, _super);
    function JobTriggerQueueItemComponent(_queueItemService) {
        var _this = _super.call(this) || this;
        _this._queueItemService = _queueItemService;
        _this._fetchItem = function () { return _this._queueItemService.getItemLastRetry(_this._itemId, ['QueueDefinition', 'ReviewerUser']); };
        return _this;
    }
    return JobTriggerQueueItemComponent;
}(JobTriggerBaseComponent));
export { JobTriggerQueueItemComponent };
